module.exports = "https://static.wmbcdn.com/uniweb/images/6fda6f1a6d9bd7d6cf5f8734c7842b8e.svg";